// removed by extract-text-webpack-plugin
module.exports = {"section":"src-components-Carousel-CarouselCard----card-module---section---4z_GE","link":"src-components-Carousel-CarouselCard----card-module---link---3Q4bC","card":"src-components-Carousel-CarouselCard----card-module---card---1Pru3","img":"src-components-Carousel-CarouselCard----card-module---img---jofHg","logoDiv":"src-components-Carousel-CarouselCard----card-module---logoDiv---3gsj4","schoolHeader":"src-components-Carousel-CarouselCard----card-module---schoolHeader---1pq_z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/CarouselCard/card.module.css
// module id = 670
// module chunks = 35783957827783